import React, { useEffect, useState, useLayoutEffect } from "react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "universal-cookie";
import {
  API_SECRET_KEY,
  JWT_COOKIE_NAME,
  GA_TRACKING_ID,
  API_OTP_SECRET_KEY
} from "../src/client/constants/index";
import { BASE_URL, Urls } from "./store/slices/urls";
import axios from "axios";
import RegistrationRoutes from "./client/routes";
import ReactGA from "react-ga";
import ErrorBoundary from "./client/components/utils/ErrorBoundary";
import { createCurrentUrl, getAbsoluteDestinationUrl, 
  certificationPage, isSignupPage, isLoginPage, 
  handleSubdomainToPathRedirect, extractKeywordFromUrl } from "./client/utils/registrationUtils"
import { getGoogleSignInCheck } from "./store/slices/Registration/GoogleSignInSlice";
import { useDispatch, useSelector } from "react-redux";
import { RegisterServiceUrls } from "./store/serviceUrl";
import Auth from "./client/components/registration/RegistrationUpdateProfile/Auth";
import { check404Url } from "./store/slices/common";
import NotFound from "./client/components/utils/notFound";
function App() {
  const dispatch = useDispatch();
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const deviceType = navigator?.userAgent?.toLowerCase()?.includes("mobile")
    ? "mobile"
    : "web";
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  const cookies = new Cookies();
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") || window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination || 'https://www.careers360.com'; // when no currenturl, case on click of url on exam page from data.
  //  Api call to check Google login CTA should be visisble or not.
    useLayoutEffect(() => {
      const path = window.location.pathname;
      const cleanPath = path.startsWith("/") ? path?.slice(1) : path;

      // checks for subdomain redirections
      if(subDomainName == "media"){ //subDomainName == "bschool" || subDomainName == "design"
        dispatch(check404Url({alias: cleanPath ,host: subDomainName}));
      }
      handleSubdomainToPathRedirect (urlCheck);
      if(isSignupPage || isLoginPage){
      let params = {};
      params.current_url= window.location?.hostname?.includes("localhost") ? createCurrentUrl() : currentUrl;
      params.certification = !!certificationFormCheck ? "True" : "False";
      dispatch(getGoogleSignInCheck(params));
      }
    }, []); 
    
// Config map
const appConfig = window.location.host.includes('careers360.net')
? {
  REACT_APP_API_URL: 'https://api.careers360.net',
  REACT_APP_MAIN_LOGIN_URL: 'https://www.careers360.net',
  REACT_APP_SUB_DOMAIN_NAME: '.careers360.net',
  REACT_APP_SESSION_DOMAIN_NAME: '.careers360.net'
}
: {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_MAIN_LOGIN_URL: process.env.REACT_APP_MAIN_LOGIN_URL,
  REACT_APP_SUB_DOMAIN_NAME: process.env.REACT_APP_SUB_DOMAIN_NAME,
  REACT_APP_SESSION_DOMAIN_NAME: process.env.REACT_APP_SESSION_DOMAIN_NAME,
};
  
  const isAuthenticated = Auth();
  const destinationDomain = appConfig?.REACT_APP_SUB_DOMAIN_NAME;
  axios.defaults.baseURL = appConfig?.REACT_APP_API_URL;
  axios.defaults.headers.common["x-api-key"] = API_SECRET_KEY;
  axios.defaults.headers.common["device-type"] = deviceType;
  axios.defaults.headers.common["x-auth-key"] = API_OTP_SECRET_KEY;
  axios.defaults.withCredentials = true;
  axios.defaults.crossDomain = true;
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.xsrfHeaderName = "X-CSRFToken";
  axios.defaults.timeout = 10000;

  if (cookies.get(JWT_COOKIE_NAME + "_access")) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
      JWT_COOKIE_NAME + "_access"
    )}`;
  } else {
    axios.defaults.headers.common["Authorization"] = null;
  }
  axios.defaults.env.FormData = appConfig

  ReactGA.initialize(GA_TRACKING_ID);
  if (window?.location?.origin?.includes("careers360.com")) {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  useEffect(() => {
    if (!cookies.get("user-agent-key")) {
      const uniqueId = Date.now().toString(16) + Math.floor(Math.random() * 1000000).toString(16);
      let date = new Date();
      cookies.set("user-agent-key", uniqueId, {   // Backend asked to pass this Unique Id
        path: "/",
        domain: destinationDomain,
        expires: new Date(date.setDate(date.getDate() + 1)),
        sameSite: "Lax",
      });
      axios.defaults.headers.common["user-agent-key"] = uniqueId
    } else {
      axios.defaults.headers.common["user-agent-key"] = cookies.get("user-agent-key")
    }
  }, [])
  
  const handlePageVisibilityChange = async () => {
    const cookies = new Cookies();
    let sessionKey = ''
    if (cookies.get(JWT_COOKIE_NAME + "_access")) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
        JWT_COOKIE_NAME + "_access"
      )}`;
    } else {
      axios.defaults.headers.common["Authorization"] = null;
    }
    //update profile user login/logout sessions check and redirection to destination url
    if(window.location.pathname?.includes("/user/update-profile")){
      
      const isAuthenticated = !!cookies.get('c360_jwt_access') ? true : false ; //to check if the user exists or not

      const currentUrls = getAbsoluteDestinationUrl();
      
      let updateProfileCase = cookies.get(`${subDomainName}-${certificationFormCheck}-updateProfile`); // to check what case of update profile are we dealing with
      let updateProfileSubmitCase = JSON.parse(sessionStorage.getItem(`${subDomainName}-${certificationFormCheck}-updateProfile`));
      if(!updateProfileCase && updateProfileSubmitCase){ // done for blank screen hide purpose on browser back button.
        window.location.href = currentUrls;
      }
      if(isAuthenticated && (updateProfileCase == 0)){
        window.location.href = currentUrls;
        cookies.remove(`${subDomainName}-${certificationFormCheck}-updateProfile`, {
          path: "/",
          domain: destinationDomain,
        });
      } else if(!isAuthenticated && (updateProfileCase == 1)){
        window.location.href = currentUrls;
        cookies.remove(`${subDomainName}-${certificationFormCheck}-updateProfile`, {
          path: "/",
          domain: destinationDomain,
        });
      }
    }

    Object.keys(cookies.getAll())?.map((value, index) => {
      if (value?.includes("SESS") && !value?.includes("CSESS360"))
        sessionKey = value
    })
    const sessionValue = cookies.get(sessionKey)
    let userData;
    try {
      const response = await axios({
        baseURL: RegisterServiceUrls.REGISTER_SERVICE + appConfig?.REACT_APP_SUB_DOMAIN_NAME,
        method: "GET",
        url: Urls.USER_DETAIL_API,
        headers: { "sid": sessionValue },
      });
      userData = response.data;
    } catch (error) {
      console.error('Error');
      return; // Exit the function if there's an error
    }
    // if user is logged in on other tab then to redirect to destination url except update profile.
    if (userData && !window.location.pathname?.includes("/user/update-profile") && !cookies.get("one-click-login")?.data) {
      const currentUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
      window.location.href = currentUrl;
    }
}

  useEffect(() => {
    // Check if page is already visible when component mounts
    if (document.visibilityState === 'visible') {
      handlePageVisibilityChange();
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handlePageVisibilityChange();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated]);


    return (
      <ErrorBoundary>
        <GoogleOAuthProvider clientId={clientId}>
          <RegistrationRoutes />
        </GoogleOAuthProvider>
      </ErrorBoundary>
    )
}

export default App;
